import { Drawer, Modal } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { GoldenPinDialogGlobalStyle, SheetHandle } from './styled';

/**
 * Shared shell for the Golden Pin modals: a centred modal on web and a bottom sheet on mweb, both
 * chrome-less so the content (hero, body, footer) can follow the design exactly.
 * Mask click and Esc never close it (the sheet has no swipe-to-close).
 */
const GoldenPinDialog = ({ open, onClose, width, children }) => {
  const isMobile = useSelector((state) => state.app.AppConfig.isMobile);

  return (
    <>
      <GoldenPinDialogGlobalStyle />
      {isMobile ? (
        <Drawer
          open={open}
          placement="bottom"
          height="auto"
          closable={false}
          maskClosable={false}
          keyboard={false}
          onClose={onClose}
          rootClassName="golden-pin-sheet-root"
          destroyOnClose
        >
          <SheetHandle />
          {children}
        </Drawer>
      ) : (
        <Modal
          open={open}
          centered
          width={width}
          footer={null}
          closable={false}
          maskClosable={false}
          keyboard={false}
          onCancel={onClose}
          rootClassName="golden-pin-modal-root"
          destroyOnClose
        >
          {children}
        </Modal>
      )}
    </>
  );
};

export default GoldenPinDialog;
